import {
	MatDialogRef,
	MAT_DIALOG_DATA,
	MatDialogContent,
	MatDialogActions,
} from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { MatDivider } from '@angular/material/list';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';

@Component({
	selector: 'app-company-setting-edit-confirmation-dialog',
	templateUrl: './company-about-dialog.component.html',
	styleUrls: [
		'./company-about-dialog.component.scss',
		'../../../../common/main.scss',
	],
	imports: [
		MatDivider,
		CdkScrollable,
		MatDialogContent,
		MatDialogActions,
		MatButton,
	],
})
export class CompanySettingDialogComponent {
	constructor(
		private dialogRef: MatDialogRef<CompanySettingDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: {}
	) {}

	onCancelClicked(): void {
		this.dialogRef.close(false);
	}

	onConfirmClicked(): void {
		this.dialogRef.close(true);
	}
}
